import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { ArrowUpRight } from "@phosphor-icons/react";

const BLOG_IMG = [
  "https://static.prod-images.emergentagent.com/jobs/59a76e4e-ce4d-4188-b575-1f3a2532803a/images/d1509d958a05ce2f0198753960f1f7b3b157af0c07c460def1c07ac600ad0069.png",
  "https://static.prod-images.emergentagent.com/jobs/59a76e4e-ce4d-4188-b575-1f3a2532803a/images/05479285365cf7dd9e3501e7186ed615650771ac71cb77ed79ca3c5e319a08f0.png",
  "https://static.prod-images.emergentagent.com/jobs/59a76e4e-ce4d-4188-b575-1f3a2532803a/images/932b2702098e3a60a64866e45a391e1859559654aaad369c253be3202b5b8867.png",
];

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/blogs").then((r) => setPosts(r.data)); }, []);

  const filtered = posts.filter((p) =>
    !q || p.title.toLowerCase().includes(q.toLowerCase()) || (p.tags || []).some((t) => t.includes(q.toLowerCase()))
  );
  const featured = filtered.find((p) => p.featured) || filtered[0];
  const rest = filtered.filter((p) => p.slug !== featured?.slug);

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
      {/* Masthead */}
      <div className="grid md:grid-cols-12 gap-10 items-end border-b border-ink pb-10">
        <div className="md:col-span-8">
          <div className="label-mono">Vol. I · The Journal</div>
          <h1 className="mt-3 font-display font-black text-6xl md:text-7xl tracking-tightest text-ink leading-[0.95]">
            Tactics that <span className="text-ink/40">actually</span> move the needle.
          </h1>
          <p className="mt-5 text-ink/65 max-w-xl leading-relaxed">
            SEO, copywriting, pricing, images, keywords — straight, no fluff.
          </p>
        </div>
        <div className="md:col-span-4 md:text-right">
          <Input placeholder="Search posts…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="blog-search" />
        </div>
      </div>

      {featured && (
        <Link to={`/blog/${featured.slug}`} data-testid={`blog-featured-${featured.slug}`}
          className="mt-12 group block border border-rule bg-white hover:bg-surface-hover transition-colors">
          <div className="grid md:grid-cols-12">
            <div className="md:col-span-6 aspect-[16/10] md:aspect-auto overflow-hidden border-b md:border-b-0 md:border-r border-rule">
              <img src={featured.cover_image_url || BLOG_IMG[0]} alt=""
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="md:col-span-6 p-8 md:p-12 flex flex-col justify-center">
              <div className="label-mono">№ 01 · Featured</div>
              <div className="mt-6 font-display text-3xl md:text-4xl font-bold leading-[1.05] tracking-tightest text-ink">
                {featured.title}
              </div>
              <p className="mt-4 text-ink/65 leading-relaxed">{featured.excerpt}</p>
              <div className="mt-8 flex items-center justify-between label-mono">
                <span>{featured.author} · {(featured.tags || []).join(" · ")}</span>
                <span className="inline-flex items-center">Read <ArrowUpRight className="w-3.5 h-3.5 ml-1 group-hover:translate-x-0.5 transition-transform" weight="bold" /></span>
              </div>
            </div>
          </div>
        </Link>
      )}

      <div className="mt-px grid md:grid-cols-3 gap-px bg-rule border border-rule">
        {rest.map((p, i) => (
          <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`}
            className="bg-white group hover:bg-surface-hover transition-colors flex flex-col">
            <div className="aspect-[16/10] overflow-hidden border-b border-rule">
              <img src={p.cover_image_url || BLOG_IMG[i % BLOG_IMG.length]} alt=""
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="p-6 flex-1 flex flex-col">
              <div className="label-mono flex items-center justify-between">
                <span>№ {String(i + 2).padStart(2, "0")}</span>
                <span>{(p.tags?.[0] || "Insight").toUpperCase()}</span>
              </div>
              <div className="mt-6 font-display text-xl font-bold leading-tight tracking-tight text-ink line-clamp-2 group-hover:text-ink-2">
                {p.title}
              </div>
              <p className="mt-3 text-ink/65 text-sm line-clamp-3 leading-relaxed flex-1">{p.excerpt}</p>
              {p.source_name && <div className="mt-4 label-mono text-ink/40">Source · {p.source_name}</div>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
